<fieldset [formGroup]="cmsForm">
    <div class="select-grey">
        <mon-form-field-select-ac
                formControlName="cms"
                name="cms"
                [monOptions]="cmsOptions"
                [monLabel]="'CMS' | translate"
                [monAllowClear]="true"
                [monReturnValue]="'id'"
                [monPlaceholder]="'None' | translate" />
    </div>

    <ng-container [formGroup]="cmsForm.controls.cmsExtra">
        @for (control of cmsExtraFormControls; track $index) {
            @let controlOptions = control.options;
            @if(control.controlType === 'input')
            {
            <div class="form-group row mt-2">
                <label class="col-form-label text-right text-bold col-sm-8"
                       [attr.for]="'domain_cms_extra_' + controlOptions.name">
                    <span>{{ controlOptions.label }}</span>
                    <span class="outer-l-smurf fas fa-question-circle"
                          aria-hidden="true"
                          [ngbTooltip]="controlOptions.tooltip"
                          placement="top-right"
                          container="body"
                          [triggers]="'focus hover'"></span>
                    @if (controlOptions.required)
                    {
                        <span>*</span>
                    }
                </label>
                <div class="col-sm-40">
                    <input type="text"
                           class="form-control"
                           [id]="'domain_cms_extra_' + controlOptions.name"
                           [formControlName]="controlOptions.name"
                           [required]="controlOptions.required"
                           [placeholder]="controlOptions.placeholder"/>
                </div>
            </div>
            }
            @if(control.controlType === 'select')
            {
            <div class="form-group">
                <form-field-select
                        [formControlName]="controlOptions.name"
                        [label]="controlOptions.label"
                        [required]="true"
                        [returnValue]="'value'"
                        [helpTxt]="controlOptions.helpTxt || ''"
                        [options]="controlOptions.controlType === 'select' ? controlOptions.selectOptions: []">
                </form-field-select>
            </div>
            }
        }
    </ng-container>

    @if(isCmsTemplate())
    {
    <div class="form-group row mt-2">
        <label class="col-form-label text-right text-bold col-sm-8"></label>
        <div class="col-sm-40">
            <span translate>CMS template is configured for this domain</span>
        </div>
    </div>
    }
</fieldset>
